





























































































































































































































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import GoodsSelect from '@/components/goods-select/index.vue'
import MemberScope from '../memberScope/index.vue'
import CouponApi from '@/api/marketing/coupon/index'
import GoodsApi from '@/api/goods/list'
@Component({
  components: {
    GoodsSelect,
    MemberScope,
  },
})
export default class CouponEdit extends AbpBase {
  tabsList: any[] = [
    {
      label: '基础信息',
      name: 'basicForm'
    },
    {
      label: '优惠规则',
      name: 'discountRuleForm'
    },
    {
      label: '领取限制',
      name: 'receiveRuleForm'
    },
    {
      label: '使用门槛',
      name: 'usedRuleForm'
    },
  ]
  couponId: string = ''
  currentTab: string = 'basicForm'
  CouponCodeValue = null
  isShowCouponSelect: boolean = false

  pager = {
    total: 0,
    pageIndex: 1,
    pageSize: 50,
  }

  CouponCodeType: any[] = [
    {
      value: 0,
      label: '固定券码',
    },
    {
      value: 1,
      label: '排序券码',
    },
  ]
  columns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '商品名称',
      width: 450,
      key: 'productName',
    },
    {
      title: '货号',
      key: 'productCode',
    },
    {
      title: '售价',
      key: 'price',
    },
    {
      title: '操作',
      width: 100,
      slot: 'action',
    },
  ]
  couponFormData = {
    code: '',
    couponType: 0,
    codeType: null,
    name: '',
    circulation: 0,
    validDateType: 0,
    expiredDay: 1,
    beginTime: null,
    endTime: null,
    description: '',
    couponCenter: false,
    pushToZhihua: false,
    cumulativeWithOtherCoupon: false,
    cumulativeWithSelf: false,
    presentation: false,
    published: false,
    discountRule: {
      discountType: 0,
      value: 0,
    },
    receiveRule: {
      memberScope: 'All',
      memberTags: [],
      limitCount: null,
    },
    usedRule: {
      isUnlimited: false,
      rules: [],
      scope: 0,
      // 包含商品品类列表
      includeCategoryCodes: [],
      // 排除商品品类列表
      excludeCategoryCodes: [],
      // 包含商品列表
      includeProductList: [],
      // 排除商品款号列表
      excludeProductList: [],
    },
  }
  conponUsedType: any[] = []
  conponRules: any[] = []
  categoriesOp: any[] = []
  selectCategories: any[] = []
  productList: any[] = []
  basicFormRuleValidate = {
    code: [{ required: true, message: '优惠券编码不能为空', trigger: 'blur' }],
    name: [{ required: true, message: '优惠券名称不能为空', trigger: 'blur' }],
  }
  get productListTemp() {
    var offset = (this.pager.pageIndex - 1) * this.pager.pageSize
    return this.productList.slice(offset, offset + this.pager.pageSize)
  }
  get computeDiscountRule() {
    return this.couponFormData.discountRule
  }
  get computeReceiveRule() {
    return this.couponFormData.receiveRule
  }
  get computeUsedRule() {
    return this.couponFormData.usedRule
  }
  get selectedItems() {
    return this.productList.map((x) => x.productId)
  }
  mounted() {
    this.getCategoriesAll()
    if (this.$route.query.id) {
      this.couponId = this.$route.query.id.toString()
      this.loadCouponInfo()
    }
  }
  generateCodeChange(val) {
    //this.isShowCouponSelect = val
    if (val) {
      this.couponFormData.couponCenter = false
    }
  }
  handleChangeType(e: any) {
    console.log(e);
    if(e == 2) {
      this.tabsList.splice(1, 1)
    }else {
      let index = this.tabsList.findIndex(item => item.name == 'discountRuleForm')
      if(index < 0) {
        this.tabsList.splice(1, 0, {
          label: '优惠规则',
          name: 'discountRuleForm'
        })
      }
    }
  }
  onPageChange(current) {
    this.pager.pageIndex = current
  }
  getCouponTypeValue(val) {
    console.log(val)
    if (val == 1) {
      this.isShowCouponSelect = true
    } else {
      this.isShowCouponSelect = false
    }
    this.couponFormData.codeType = val
  }
  getTextByScopeType(type) {
    // type 0品类的文字, 1选商品的文字
    let res = ''
    switch (this.computeUsedRule.scope) {
      case 0:
        res = {
          '0': '排除分类',
          '1': '添加排除商品',
        }[type]
        break
      case 1:
        res = {
          '0': '可用分类',
          '1': '添加可用商品',
        }[type]
        break
      case 2:
        res = {
          '0': '可用分类',
          '1': '添加排除商品',
        }[type]
        break
      default:
        break
    }
    return res
  }

  /**
   * 获取商品分类
   */
  getCategoriesAll() {
    GoodsApi.getCategoriesAll().then((res) => {
      if (res.data.items) {
        this.categoriesOp = res.data.items.map((child) => {
          return {
            value: child.id,
            text: child.fullName,
          }
        })
      }
    })
  }

  getRuleTypeUnit(type) {
    switch (type) {
      case 0:
        return '折'
      case 1:
        return '件'
      case 2:
        return '元'
      default:
        return ''
    }
  }

  getInputNumberMax(type) {
    // type 0 满X折可用 1 满X件可用 2 满X元可用
    let res = Infinity
    switch (type) {
      case 0:
        res = 10
        break
      case 1:
        res = Infinity
        break
      case 2:
        res = Infinity
        break
      default:
        break
    }
    return res
  }

  getInputNumberMin(type) {
    // type 0 满X折可用 1 满X件可用 2 满X元可用
    let res = -Infinity
    switch (type) {
      case 0:
        res = 0.1
        break
      case 1:
        res = 1
        break
      case 2:
        res = 0.01
        break
      default:
        break
    }
    return res
  }

  selectChange(val, index) {
    // console.log('val', val)
    // console.log('index', index)
    const { conponRules } = this
    const rulesLen = conponRules.length - 1
    if (rulesLen !== index || (rulesLen + 1) % 2 === 0) {
      conponRules[index - 1].isAnd = val
    }
  }

  usedTypeChange(arr) {
    const res: any = []
    arr.forEach((element) => {
      const findItem = this.conponRules.find((item) => element === item.ruleType)
      if (!findItem) {
        res.push({
          ruleType: element,
          value: null,
          isAnd: 1,
        })
      } else {
        res.push(findItem)
      }
    })
    this.conponRules = res
    // 重计算isAnd的值
    for (let i = 0, len = res.length; i < len; i++) {
      const next = i + 1
      if (next >= len) break
      this.selectChange(res[next].isAnd, next)
    }
  }
  loadCouponInfo() {
    CouponApi.getCoupon(this.couponId).then((res) => {
      this.couponFormData = res.data
      this.couponFormData.beginTime = new Date(res.data.beginTime)
      this.couponFormData.endTime = new Date(res.data.endTime)
      if(res.data.couponType == 2) {
        let index = this.tabsList.findIndex(item => item.name == 'discountRuleForm')
        if(index > -1) {
          this.tabsList.splice(index, 1)
        }
      }
      const { usedRule } = this.couponFormData
      if (!usedRule.isUnlimited) {
        this.conponRules = usedRule.rules.map((item) => {
          item.isAnd = Number(item.isAnd)
          return item
        })
        this.conponUsedType = usedRule.rules.map((item) => item.ruleType)
      }
      // 全部商品
      if (usedRule.scope == 0) {
        this.selectCategories = usedRule.excludeCategoryCodes
        this.productList = usedRule.excludeProductList
      }
      // 部分商品就查看有没有可用分类或可用商品
      if (usedRule.scope == 1) {
        this.selectCategories = usedRule.includeCategoryCodes
        this.productList = usedRule.includeProductList
      }
      // 分类商品就查看有没有选可用分类
      if (usedRule.scope == 2) {
        this.selectCategories = usedRule.includeCategoryCodes
        this.productList = usedRule.excludeProductList
      }
      this.pager.total = this.productList.length
    })
  }
  removeProduct(index: number) {
    this.productList.splice(index, 1)
  }
  goodsOnChange(list) {
    this.productList = this.productList.concat(
      list.map((t) => {
        return {
          productId: t.id,
          pictureUrl: t.pictureUrl,
          productName: t.name,
          productCode: t.code,
          marketPrice: t.marketPrice,
          price: t.price,
          displayOrder: 0,
        }
      })
    )
  }
  isInteger(val) {
    return /^([1-9]\d*(\.\d+)?|0)$/.test(val)
  }
  save() {
    ;(this.$refs['basicForm'] as any).validate((valid) => {
      if (valid) {
        let hasError = false
        // computeUsedRule优惠券门槛规则
        // computeReceiveRule优惠券领取规则
        const { conponUsedType, conponRules, computeUsedRule, computeReceiveRule, computeDiscountRule } = this
        if (this.isShowCouponSelect && (this.couponFormData.codeType === null || this.couponFormData.codeType === undefined)) {
          this.$Notice.warning({
            title: '请先选择优惠券券码类型',
          })
          return
        }
        if (!computeDiscountRule.value && this.couponFormData.couponType != 2) {
          this.currentTab = 'discountRuleForm'
          this.$Notice.warning({
            title: '请先完善优惠规则',
          })
          return
        }
        // memberScope: All 全部、Tag 指定会员标签
        const { memberScope, memberTags, limitCount } = computeReceiveRule
        if (memberScope === 'Tag') {
          if (!memberTags.length) {
            this.currentTab = 'receiveRuleForm'
            this.$Notice.warning({
              title: '请先指定相关会员标签',
            })
            return false
          }
        }
        console.log(this.isInteger(limitCount))
        if (!this.isInteger(limitCount) && !this.isShowCouponSelect) {
          this.currentTab = 'receiveRuleForm'
          this.$Notice.warning({
            title: '限领数量有误',
          })
          return false
        }
        let copyObj = JSON.parse(JSON.stringify(this.couponFormData))
        // 检查优惠券门槛信息
        if (!computeUsedRule.isUnlimited) {
          if (conponUsedType.length) {
            for (let index = 0, len = conponRules.length; index < len; index++) {
              const element = conponRules[index]
              if (!element.value) {
                this.currentTab = 'usedRuleForm'
                this.$Notice.warning({
                  title: '请先完善优惠券门槛信息',
                })
                hasError = true
                break
              }
            }
            // 没问题，存数据
            copyObj.usedRule.rules = conponRules
          } else {
            this.currentTab = 'usedRuleForm'
            this.$Notice.warning({
              title: '请先完善优惠券门槛信息',
            })
            return
          }
        } else {
          copyObj.usedRule.rules = []
        }
        if (hasError) return false
        const { selectCategories, productList } = this
        // 全部商品
        if (computeUsedRule.scope == 0) {
          copyObj.usedRule.excludeCategoryCodes = selectCategories
          copyObj.usedRule.excludeProductList = productList
          // 重置旧的
          copyObj.usedRule.includeCategoryCodes = []
          copyObj.usedRule.includeProductList = []
        }
        // 部分商品就查看有没有可用分类或可用商品
        if (computeUsedRule.scope == 1) {
          // 夏娃的先去掉商品分类
          if (!productList.length) {
            this.currentTab = 'usedRuleForm'
            this.$Notice.warning({
              title: '请选择可用商品',
            })
            return false
          }
          copyObj.usedRule.includeCategoryCodes = selectCategories
          copyObj.usedRule.includeProductList = productList
          // 重置旧的
          copyObj.usedRule.excludeCategoryCodes = []
          copyObj.usedRule.excludeProductList = []
        }
        // 分类商品就查看有没有选可用分类
        if (computeUsedRule.scope == 2) {
          if (!selectCategories.length) {
            this.currentTab = 'usedRuleForm'
            this.$Notice.warning({
              title: '请选择可用分类',
            })
            return false
          }
          copyObj.usedRule.includeCategoryCodes = selectCategories
          copyObj.usedRule.excludeProductList = productList
          // 重置旧的
          copyObj.usedRule.excludeCategoryCodes = []
          copyObj.usedRule.includeProductList = []
        }
        if (
          this.isShowCouponSelect &&
          (this.couponFormData.codeType !== null || this.couponFormData.codeType !== undefined)
        ) {
          copyObj.codeType = this.couponFormData.codeType
          copyObj.receiveRule.limitCount = 1
        }
        if (this.couponId === '') {
          CouponApi.addCoupon(copyObj).then((res) => {
            this.$Message.success('保存成功')
            this.$router.push({
              name: 'couponList',
            })
          })
        } else {
          CouponApi.updateCoupon(this.couponId, copyObj).then((res) => {
            this.$Message.success('保存成功')
            this.$router.push({
              name: 'couponList',
            })
          })
        }
      } else {
        this.currentTab = 'basicForm'
        this.$Notice.warning({
          title: '请先完善优惠券基础信息',
        })
      }
    })
  }
}
